import $ from "jquery";
import Swiper, { Navigation } from "swiper";

Swiper.use([Navigation]);

/**
 * Configure Swiper for retailers slider
 */
$(() => {
  $(".retailers-slider").each((_, elem) => {
    new Swiper($(elem).find(".swiper-container")[0], {
      centeredSlides: true,
      loop: true,
      loopedSlides: 5,
      navigation: {
        nextEl: $(elem).find(".swiper-button-next")[0],
        prevEl: $(elem).find(".swiper-button-prev")[0],
      },
      slidesPerView: "auto",
      speed: 750,
    });
  });
});
